import create, { GetState, Mutate, SetState, StoreApi } from "zustand";
import { persist } from "zustand/middleware";

export type PartnerID = "greenscreens" | "truckstop" | "dat";

export type PartnerAuthState = {
  connected: boolean;
  email?: string;
  // Right now greenscreens only needs to persist the email for auth state,
  // future integrations might need more like an auth token, or something along those lines.
};

type BenchmarkRateEstimatorStoreType = {
  partners: Record<PartnerID, PartnerAuthState>;
  setPartnerAuth: (partner: PartnerID, auth: PartnerAuthState) => void;
  resetPartnerAuth: (partner: PartnerID) => void;
};

export const useBenchmarkRateEstimatorStore = create<
  BenchmarkRateEstimatorStoreType,
  SetState<BenchmarkRateEstimatorStoreType>,
  GetState<BenchmarkRateEstimatorStoreType>,
  Mutate<StoreApi<BenchmarkRateEstimatorStoreType>, [["zustand/persist", Partial<BenchmarkRateEstimatorStoreType>]]>
>(
  persist(
    (set) => ({
      partners: {
        greenscreens: { connected: false as boolean },
        truckstop: { connected: false as boolean },
        dat: { connected: false as boolean },
      },
      setPartnerAuth: (partner, auth) =>
        set((state) => ({
          partners: {
            ...state.partners,
            [partner]: { ...auth },
          },
        })),
      resetPartnerAuth: (partner) =>
        set((state) => ({
          partners: {
            ...state.partners,
            [partner]: { connected: false },
          },
        })),
    }),
    {
      name: "benchmarkRateEstimatorStore",
      version: 1,
    }
  )
);
